import React, { useEffect, useState, createRef } from "react";
import visaIcon from "../assets/images/payment_images.webp";
import logo2 from "../assets/images/logo-2.png";
import { toast } from "react-toastify";
import { newsletter } from "../services/MyAccountService";
import { validateForm } from "../services/FormValidation";
import appleStore from '../assets/images/apple-store.png'; 
import googlePlay from '../assets/images/google-play.png';
import { Helmet } from "react-helmet";
import {
  InputComponent,
  InvalidFeedback,
  InputGroupComponent,
  ButtonComponent,
} from "../components/form_element";
import { getSettings, getFooterMenuService, getSeoAnalytics } from "../services/HomePageService";

const SiteFooter = (props) => {
  useEffect(() => {
    getFooterMenu();
    getSettingsData();
    getSeoData();
  }, []);
  const inputRef = createRef();

  const [formData, setFormData] = useState({
    email: ""
  });
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validateOptions = {
      email: {
        required: true,
        type: "email",
      }

    };

    const { isValid, errors } = validateForm(validateOptions, formData);
    if (isValid) {
      console.log('asgi');

      setLoader(true);
      const res = await newsletter(formData);
      if (res) {
        console.log(res);
        if (res.status === 200) {
          toast.success("Subscribed Successfully");
          setFormData({ email: "" });
          // history.push("/");

        } else {
          if (res.status == 423) {
            setFormData({ email: "" });

            toast.error("Already Subscribed");

          }
          setErrorResponse(res);
        }
        setLoader(false);
      }
    } else {
      setErrorState(errors);
    }
  };
  const [errorState, setErrorState] = useState({});
  const [errorResponse, setErrorResponse] = useState("");
  const [loader, setLoader] = useState(false);

  const [footerMenu, setFooterMenu] = useState({ loader: true, data: [] });
  const [settings, setSettings] = useState({ loader: true, data: [] });
  const [seoData, setSeoData] = useState({ loader: true, data: [] });


  const getFooterMenu = async () => {
    const catData = await getFooterMenuService();
    if (catData) {
      setFooterMenu({
        loader: false,
        data: catData,
      });
    }
  };
  const handleInputChange = (e) => {
    setErrorResponse("");
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    setErrorState({
      ...errorState,
      [e.target.name]: "",
    });
  };
  const getSettingsData = async () => {
    const settData = await getSettings();
    if (settData) {
      setSettings({
        loader: false,
        data: settData,
      });
    }
  };

  const getSeoData = async () => {
    const setSeo = await getSeoAnalytics();
    if (setSeo) {
      setSeoData({

        loader: false,
        data: setSeo,
      });
    }
  };
  return (
    <footer className='footer'>
      <div className='footer-first-row'>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-md-4 col-sm-4 col-xs-12'>
              <div className='social-links-footer'>
                <span>Social Media Connection</span>
                <ul>
                  <li>
                    <a title="facebook" target="_blank" href={settings.data.facebook}>
                      <i className='uil uil-facebook-f'></i>
                    </a>
                  </li>
                  <li>
                    <a title="twitter" target="_blank" href={settings.data.twitter}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M18.205 2.25h3.308l-7.227 8.26l8.502 11.24H16.13l-5.214-6.817L4.95 21.75H1.64l7.73-8.835L1.215 2.25H8.04l4.713 6.231l5.45-6.231Zm-1.161 17.52h1.833L7.045 4.126H5.078L17.044 19.77Z" /></svg>
                    </a>
                  </li>
                  <li>
                    <a title="tiktok" target="_blank" href={settings.data.tiktok}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M16.6 5.82s.51.5 0 0A4.278 4.278 0 0 1 15.54 3h-3.09v12.4a2.592 2.592 0 0 1-2.59 2.5c-1.42 0-2.6-1.16-2.6-2.6c0-1.72 1.66-3.01 3.37-2.48V9.66c-3.45-.46-6.47 2.22-6.47 5.64c0 3.33 2.76 5.7 5.69 5.7c3.14 0 5.69-2.55 5.69-5.7V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3s-1.88.09-3.24-1.48z" /></svg>
                    </a>
                  </li>
                  <li>
                    <a title="snapchat" target="_blank" href={settings.data.snapchat}>
                      <i className='uil uil-snapchat-alt'></i>
                    </a>
                  </li>
                  <li>
                    <a title="threads" target="_blank" href={settings.data.threads}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M16.705 11.108c-.162-2.987-1.794-4.697-4.534-4.714c-1.652-.01-3.033.69-3.879 1.973L9.8 9.4c.634-.961 1.635-1.16 2.36-1.153c.903.006 1.583.268 2.024.78c.32.372.535.887.642 1.536c-.8-.136-1.666-.178-2.59-.125c-2.606.15-4.28 1.67-4.168 3.781c.057 1.071.59 1.993 1.502 2.595c.77.509 1.764.757 2.795.701c1.363-.075 2.432-.595 3.178-1.545c.566-.722.924-1.658 1.082-2.836c.65.392 1.13.907 1.397 1.527c.452 1.054.478 2.786-.935 4.198c-1.238 1.236-2.726 1.772-4.975 1.788c-2.495-.018-4.382-.819-5.608-2.378c-1.15-1.46-1.743-3.57-1.765-6.269c.022-2.7.616-4.809 1.765-6.27c1.226-1.559 3.113-2.359 5.608-2.377c2.513.019 4.432.822 5.706 2.39c.625.768 1.095 1.734 1.406 2.86l1.766-.47c-.377-1.387-.969-2.582-1.774-3.573c-1.633-2.01-4.033-3.039-7.11-3.06c-3.071.021-5.433 1.055-7.019 3.071c-1.411 1.795-2.14 4.306-2.164 7.436c.024 3.13.753 5.627 2.164 7.422c1.587 2.016 3.96 3.05 7.03 3.071c2.731-.019 4.655-.734 6.24-2.317c2.075-2.073 2.012-4.67 1.329-6.264c-.525-1.225-1.57-2.206-2.98-2.81Zm-4.438 4.557c-1.142.064-2.328-.448-2.387-1.546c-.043-.814.58-1.722 2.457-1.83a9.389 9.389 0 0 1 2.533.174c-.216 2.702-1.485 3.14-2.603 3.202Z" /></svg>
                    </a>
                  </li>
                  <li>
                    <a title="instagram" target="_blank" href={settings.data.instagram}>
                      <i className='uil uil-instagram'></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className='col-md-4 col-sm-4 col-xs-12'>
              <span>Email Support</span>
              <ul className='call-email-alt'>
                <li>
                  <a href={'mailto:' + settings.data.email} className='callemail'>
                    <i className='uil uil-envelope-alt'></i>
                    {settings.data.email}
                  </a>
                </li>
              </ul>
            </div>

            <div className='col-md-4 col-sm-4 col-xs-12'>
              <span>payment Method</span>
              <ul id='paypal-gateway' className='financial-institutes'>
                <li className='financial-institutes__logo'>
                  <img alt='Visa' title='Visa' src={visaIcon} />
                </li>
                {/* <li className='financial-institutes__logo'>
                  <img alt='Visa' title='Visa' src={visaIcon1} />
                </li>
                <li className='financial-institutes__logo'>
                  <img alt='MasterCard' title='MasterCard' src={visaIcon2} />
                </li> */}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className='footer-second-row'>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-sm-3'>
              <div className='foot-logo'>
                <img alt="logo" src={logo2} />
              </div>

              <div className='second-row-item-payment'>
                <h4>Experience a better shopping</h4>
                <div className='newsletter-input'>

                  <div className="modal-contents">

                    <div className="store-buttons">
                      <a href="https://apps.apple.com/ae/app/day-to-day-online/id6504225370" target="_blank" rel="noopener noreferrer">
                        <img src={appleStore} alt="Apple Store" className="store-button" />
                      </a>
                      <a href="https://play.google.com/store/apps/details?id=com.daytodayonline" target="_blank" rel="noopener noreferrer">
                        <img src={googlePlay} alt="Google Play" className="store-button" />
                      </a>
                    </div>
                  </div>

                </div>
              </div>
              {/* <div className='second-row-item-payment'>
                <h4>Newsletter</h4>
                <div className='newsletter-input'>
                
                  <InputGroupComponent className='form-group pos_rel'>
                    <InputComponent
                      inputRef={inputRef}
                      id='email'
                      name='email'
                      type='text'
                      placeHolder='Email Address'
                      inputClassName='form-control input-md'
                      isInvalid={errorState.email ? true : false}
                      onChange={handleInputChange}
                      value={formData.email}
                    />
                  
                    <InvalidFeedback>{errorState.firstname}</InvalidFeedback>
                  </InputGroupComponent>
                  <button
                    onClick={handleSubmit} className='newsletter-btn hover-btn' aria-label='newsletter' type='submit'>
                    <i className='uil uil-telegram-alt'></i>
                  </button>
             
                </div>
              </div> */}
            </div>
            <div className='col-sm-4'>
              <div className='second-row-item'>
                <h4>Categories</h4>
                <CategoryList data={footerMenu.data} />
              </div>
            </div>
            <div className='col'>
              <div className='second-row-item'>
                <h4>Help</h4>
                <ul>
                  <li>
                    <a href='/faq'>FAQ’s </a>
                  </li>
                  <li>
                    <a href='/privacy-policy'>Privacy Policy </a>
                  </li>
                  <li>
                    <a href='/return-policy'>Return Policy </a>
                  </li>

                  <li>
                    <a href='/terms-conditions'>Terms & Conditions </a>
                  </li>
                  <li>
                    <a href='/cancellation-policy'>Cancellation & Policy </a>
                  </li>

                </ul>
              </div>
            </div>
            <div className='col'>
              <div className='second-row-item'>
                <h4> Account</h4>
                <ul>
                  <li>
                    <a href='/login'>Sign In</a>
                  </li>
                  <li>
                    <a href='/orders'>Order Status </a>
                  </li>
                  <li>
                    <a href='/wishlists'>My Wishlist</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className='col'>
              <div className='second-row-item'>
                <h4>About Day to day</h4>
                <ul>
                  <li>
                    <a href='/company'>About Us</a>
                  </li>
                  {/* <li>
                    <a href='/support'>Support</a>
                  </li> */}
                  <li>
                    <a href='/contact-us'>Contact</a>
                  </li>
                  {/* <li>
                    <a href='/careers'>Careers</a>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='footer-last-row'>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-md-12'>
              {/* <div className='footer-bottom-links'>
                <ul>
                  <li>
                    <a href='/privacy-policy'>Privacy Policy</a>
                  </li>
                  <li>
                    <a href='/terms-conditions'>Term & Conditions</a>
                  </li>
                </ul>
              </div> */}
              <div className='copyright-text'>
                <i className='uil uil-copyright'></i>Copyright 2024{" "}
                <b>Day To Day</b> . All rights reserved
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddHelmet data={seoData.data} />
    </footer>
  );
};

const CategoryList = ({ data }) => {
  return (
    <ul className='blk-2'>
      {data &&
        data.map(({ id, footerStatus, title, slug }) =>

          <li>
            <a href={`/category/${slug}`}>{title}</a>
          </li>

        )}
    </ul>
  );
};
const AddHelmet = ({ data }) => {
  // var script= document.createElement('script');
  //     setSeo.forEach((data) => {
  //       script.text = data.analytics_code;
  //       document.head.appendChild(script);
  //     })
  return (
    <>
      {/* <Helmet> */}
      {data &&
        data.map(({ code_position, analytics_code }) => (
          <>

            {code_position == 2 || code_position == 3 ? (
              <div dangerouslySetInnerHTML={{ __html: analytics_code }} />
            ) : ("")
            }

          </>
        ))}
      {/* </Helmet> */}
    </>

  );
};

export default SiteFooter;
